import * as THREE from 'three';

import { Point3d } from '../../utilities/math-helpers';

export class PCLoader {
  static simpleParse(pcData: Point3d[], color: number) {
    const geometry = new THREE.BufferGeometry();

    const vertices = pcData.reduce((prev: number[], next) => {
      prev.push(next.x, next.y, next.z);
      return prev;
    }, []);

    geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
    const material = new THREE.PointsMaterial({
      color,
      size: 1.0,
      sizeAttenuation: false,
    });

    return new THREE.Points(geometry, material);
  }
}
